module.exports = __webpack_public_path__ + "img/mediaIcon3.ed32fad9.png";